import { connectedStore } from '../../store';
import getInitialSetupCompleted from '../selectors/initial-setup-completed';

const isSetupCompleted = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return Boolean(getInitialSetupCompleted(state));
};

export default isSetupCompleted;
